import { enqueueSnackbar } from 'actions';
import {
	fetchEmailsRequest, fetchEmailsSuccess, fetchEmailsFailure,
	addEmailRequest,    addEmailSuccess,    addEmailFailure,
	updateEmailRequest, updateEmailSuccess, updateEmailFailure,
	removeEmailRequest, removeEmailSuccess, removeEmailFailure,
} from '../actions/emailActions';
import {
	GetEmailsRequest,
	AddEmailRequest,
	UpdateEmailRequest,
	DeleteEmailRequest,
} from '../requests/emailRequests';

const normalise = (raw) => ({
	id:          raw.id          ?? raw.Id,
	creationDate: raw.creationDate ?? raw.CreationDate ?? null,
	creationUser: raw.creationUser ?? raw.CreationUser ?? '',
	wrongEmail:  raw.wrongEmail  ?? raw.WrongEmail  ?? '',
	rightEmail:  raw.rightEmail  ?? raw.RightEmail  ?? '',
	changeDate:  raw.changeDate  ?? raw.ChangeDate  ?? null,
	changeUser:  raw.changeUser  ?? raw.ChangeUser  ?? '',
});

export const fetchEmails = (userId) => async (dispatch) => {
	dispatch(fetchEmailsRequest());
	await GetEmailsRequest(userId).then((response) => {
		dispatch(fetchEmailsSuccess(response.data.map(normalise)));
	}).catch((error) => {
		dispatch(fetchEmailsFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const addEmail = ({ userId, wrongEmail, rightEmail }) => async (dispatch) => {
	dispatch(addEmailRequest());
	await AddEmailRequest(userId, wrongEmail, rightEmail).then(() => {
		dispatch(addEmailSuccess());
		dispatch(fetchEmails(userId));
	}).catch((error) => {
		dispatch(addEmailFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const updateEmail = ({ userId, id, wrongEmail, rightEmail, date }) => async (dispatch) => {
	dispatch(updateEmailRequest());
	await UpdateEmailRequest(userId, id, wrongEmail, rightEmail, date).then((response) => {
		dispatch(updateEmailSuccess(normalise(response.data)));
	}).catch((error) => {
		dispatch(updateEmailFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const removeEmail = (userId, id) => async (dispatch) => {
	dispatch(removeEmailRequest());
	await DeleteEmailRequest(userId, id).then(() => {
		dispatch(removeEmailSuccess(id));
	}).catch((error) => {
		dispatch(removeEmailFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};